import React from 'react';
// MATERIAL-UI
import { Typography } from '@material-ui/core';
// REDUX
import { useSelector } from 'react-redux';
// CLSX
import clsx from 'clsx';
// COMPONENTS
import Cards from './components/Cards';
// IMAGES
import Contrato from '../../../../images/Funcionamento/orcamento-carrefour.png';
import Coleta from '../../../../images/Funcionamento/delivery-carrefour.png';
import Reparo from '../../../../images/Funcionamento/smartphone-carrefour.png';
import Pagamento from '../../../../images/Funcionamento/cartao-de-credito-carrefour.png';
import Entrega from '../../../../images/Funcionamento/entregador-carrefour.png';
// STYLES
import styles from './style';

const Funcionamento = () => {
  const classes = styles();
  const partnerData = useSelector((state) => state.PartnerStoreReducer);
  const { branch } = partnerData;
  const { branch_name } = branch;
  return (
    <div id="how-it-works" className={classes.comoFunciona}>
      <div className={classes.comoFuncionaCards}>
        <div
          className={clsx(classes.comoFuncionaCardsIntern, {
            [classes.comoFuncionaCardsInternCarrefour]: branch_name === 'Carrefour',
            [classes.comoFuncionaCardsInternReparofone]: branch_name === 'Limelocker',
          })}
        >
          <Typography
            className={clsx(classes.title, {
              [classes.titleCarrefour]: branch_name === 'Carrefour',
              [classes.titleReparofone]: branch_name === 'Limelocker',
            })}
          >
            Conheça o processo da Reparofone
          </Typography>
          <Cards
            image={Contrato}
            step="Passo 1"
            title="Orçamento"
            text="Faça seu pré-orçamento completamente online (ou entre em contato conosco)"
          />
          <Cards
            image={Coleta}
            step="Passo 2"
            title="Coleta"
            text="Agende conforme sua conveniência!"
          />
          <Cards
            image={Reparo}
            step="Passo 3"
            title="Reparo"
            text="Em parceria com a Trocafone - e parceiros homologados - oferecemos a melhor qualidade do mercado!*"
          />
          <Cards
            image={Pagamento}
            step="Passo 4"
            title="Pagamento"
            text="Pague por link em até 10x somente depois que o aparelho é reparado e testado!"
          />
          <Cards
            image={Entrega}
            step="Passo 5"
            title="Entrega"
            text="Receba seu celular no conforto da sua casa ou onde for mais cômodo!"
          />
        </div>
        <div
          className={clsx(classes.paragraphs, {
            [classes.paragraphsCarrefour]: branch_name === 'Carrefour',
            [classes.paragraphsReparofone]: branch_name === 'Limelocker',
          })}
        >
          <p className={classes.infoParagraph}>*Com garantia de 3 meses no reparo realizado</p>
        </div>
      </div>
    </div>
  );
};

export default Funcionamento;
